import CriteriaLogo from "resources/images/Criteria-Logo-RGB.svg";

export const getLogo = () => (
  <img
    src={CriteriaLogo}
    alt="Criteria"
    style={{ width: "131px" }}
    className="company-logo"
  />
);

export const getSalutation = (userName: string = "Stanley") => (
  <h2>Hi {userName},</h2>
);

export const getClosing = () => (
  <div>
    <p className="m-0">Best,</p>
    <p>Coach Bo</p>
  </div>
);

export const getArrowCell = (difference: number) => {
  let className = "neutral";
  let arrow = "→";
  if (difference > 0) {
    className = "up";
    arrow = "↑";
  } else if (difference < 0) {
    className = "down";
    arrow = "↓";
  }

  return (
    <td className="td td-center">
      <span className={className}>{arrow}</span>
    </td>
  );
};
